<template>
  <div class="page">
    <h2>Account</h2>
    <div>
      <table>
        <tr>
          <td>Id:</td>
          <td>{{account.id}}</td>
        </tr>
        <tr>
          <td>Type:</td>
          <td>{{account.type}}</td>
        </tr>
        <tr>
          <td>Name:</td>
          <td>{{account.name}}</td>
        </tr>
        <tr>
          <td>Sector:</td>
          <td>
            <select type="text" v-model="account.sector">
              <option value="energy">Energy</option>
              <option value="materials">Materials</option>
              <option value="industrials">Industrials</option>
              <option value="consumer_discretionary">Consumer Discretionary</option>
              <option value="consumer_staples">Consumer Staples</option>
              <option value="health_care">Health Care</option>
              <option value="financials">Financials</option>
              <option value="information_technology">Information Technology</option>
              <option value="telecommunication_services">Telecommunication Services</option>
              <option value="utilities">Utilities</option>
              <option value="real_estate">Real Estate</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Employees:</td>
          <td><input type="number" min="0" v-model="account.employees"/></td>
        </tr>
      </table>
      <button @click="cancel()">Cancel</button>
      <button @click="save()">Save</button>

      <!-- <pre>{{account}}</pre> -->
      
    </div>

    <h2>Backup</h2>
    <button @click="backup">Backup</button>

    <h2>Restore</h2>
    <div>
      <input id="backupFileInput" type="file" @change="onFileChange"/>
      <button @click="restore">Apply</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'account',
  computed: {
    ...mapState([
      'apiAccount',
      'account'
    ])
  },
  methods: {
    refreshAccount () {
      this.$store.dispatch('loadAccount')
    },
    cancel () {
      this.$store.dispatch('loadAccount')
    },
    save () {
      this.$store.dispatch('saveAccount')
    },
    onFileChange (event) {
      if (event.target.files) {
        this.backupFile = event.target.files[0]
      }
    },
    backup () {
      this.apiAccount.download('/account/backup', this.account.name + '_backup.json')
    },
    restore () {
      if (!this.backupFile) return
      var formData = new FormData()
      formData.set('backup_file', this.backupFile)
      this.apiAccount.post('/account/backup', formData).then( () => {
        alert('Account restored succesfully')
        this.$store.dispatch('loadAccount')
      })
      this.backupFile = null
      document.getElementById('backupFileInput').value = null
    }
  }
}
</script>
